/* FB | Sepet on-isitma v5 — additive; calisan yapiyi bozmaz.
   KOF + "Hediye paketi ekle" butonu drawer KAPALIYKEN aninda + her re-render'da SENKRON
   (MutationObserver callback'inde, paint oncesi) geri konur => acilis/yenilemede flas (gidip-gelme) yok.
   idempotent: data-fb-kof / .fb-gw-sumbtn kontrolu -> fb-kof-eager / fb-gift-wrap ile cakismaz, cift olmaz.
   v5: Drawer ICINDEKI gorsellerin BIREBIR src/srcset URL'leri sayfa acilir acilmaz on-bellege alinir
   (eski surum orijinal boyut URL'sini isitiyordu, drawer width=250 varyanti kullandigi icin cache iskaliyordu).
   Boylece sepet acildiginda gorseller ANINDA hazir, pop-in yok. */
(function(){
  'use strict';
  if(window.__fbCartPreload) return; window.__fbCartPreload=true;

  var GIFT_PRICE_TXT='+80,00 \u20ba';

  function injectKofNow(){
    try{
      var tpl=document.getElementById('fb-cart-upsell-template');
      if(!tpl || !tpl.content) return;
      var ds=document.querySelectorAll('cart-drawer-component dialog');
      for(var i=0;i<ds.length;i++){
        var d=ds[i];
        if(d.querySelector('[data-fb-kof]')) continue;
        var summary=d.querySelector('.cart-drawer__summary');
        if(summary && summary.parentNode){ summary.parentNode.insertBefore(tpl.content.cloneNode(true), summary); }
      }
    }catch(e){}
  }

  function injectGiftBtnNow(){
    try{
      var sums=document.querySelectorAll('cart-drawer-component .cart-drawer__summary');
      for(var i=0;i<sums.length;i++){
        var sum=sums[i];
        if(sum.querySelector('.fb-gw-sumbtn')) continue;
        var b=document.createElement('button');
        b.type='button';
        b.className='fb-gw-sumbtn';
        b.innerHTML='<span class="fb-gw-frame" aria-hidden="true"></span><span class="fb-gw-gift" aria-hidden="true"></span><span class="fb-gw-bt">Hediye paketi ekle</span><span class="fb-gw-bok" aria-hidden="true"></span><span class="fb-gw-bp">'+GIFT_PRICE_TXT+'</span>';
        var anchor=sum.querySelector('.cart-totals, .cart__summary-totals')||sum.firstElementChild;
        if(anchor && anchor.parentNode===sum) sum.insertBefore(b, anchor); else sum.insertBefore(b, sum.firstChild);
      }
    }catch(e){}
  }

  /* FB v5: Drawer icindeki TUM gorselleri (urun gorselleri + KOF upsell) hemen yuklemeye zorla.
     - loading=eager: dialog kapaliyken bile tarayici indirir (lazy bekletmez)
     - decoding=async: ana is parcacigini kitlemez
     - new Image() ile src VE srcset birebir on-bellege alinir -> acilista ayni URL cache'ten gelir
     idempotent: __fbWarm isareti, ayni img'i iki kez isitmez. */
  function warmDrawerImages(){
    try{
      var imgs=document.querySelectorAll('cart-drawer-component img');
      for(var i=0;i<imgs.length;i++){
        var im=imgs[i];
        if(im.__fbWarm) continue; im.__fbWarm=true;
        try{ im.loading='eager'; im.setAttribute('loading','eager'); }catch(e){}
        try{ im.decoding='async'; }catch(e){}
        try{
          var pre=new Image();
          try{ pre.decoding='async'; pre.fetchPriority='low'; }catch(e){}
          var ss=im.getAttribute('srcset'); if(ss) pre.srcset=ss;
          var sz=im.getAttribute('sizes'); if(sz) pre.sizes=sz;
          var s=im.getAttribute('src'); if(s) pre.src=s;
        }catch(e){}
      }
    }catch(e){}
  }

  function instant(){ injectKofNow(); injectGiftBtnNow(); warmDrawerImages(); }

  var mo=null, kept=false;
  function keep(){
    try{
      var cd=document.querySelector('cart-drawer-component');
      if(!cd || kept) return;
      kept=true;
      mo=new MutationObserver(function(){ injectKofNow(); injectGiftBtnNow(); warmDrawerImages(); });
      mo.observe(cd,{childList:true,subtree:true});
    }catch(e){}
  }

  /* FB v5: /cart.js gorselleri hem orijinal hem drawer'in kullandigi width=250 varyantiyla isitilir
     (sepete urun eklenince gelen yeni render ayni URL'yi cache'ten bulur). */
  function v250(u){ try{ return u + (u.indexOf('?')>-1?'&':'?') + 'width=250'; }catch(e){ return u; } }
  function preloadGiftImages(){
    try{
      fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(c){
        if(!c||!c.items) return;
        var seen={};
        function warm(u){ if(!u||seen[u]) return; seen[u]=1; var im=new Image(); try{ im.decoding='async'; im.fetchPriority='low'; }catch(e){} im.src=u; }
        c.items.forEach(function(it){
          var u = it.image || (it.featured_image && it.featured_image.url);
          if(u){ warm(u); warm(v250(u)); }
        });
      }).catch(function(){});
    }catch(e){}
  }
  function idle(){ try{ if('requestIdleCallback' in window){ requestIdleCallback(function(){ preloadGiftImages(); }, {timeout:1200}); } else { setTimeout(preloadGiftImages, 500); } }catch(e){ setTimeout(preloadGiftImages, 500); } }

  function boot(){
    instant(); keep(); idle();
    document.addEventListener('cart:update', function(){ instant(); });
    document.addEventListener('fb:cart-drawer-render-fixed', function(){ warmDrawerImages(); });
    var tries=0; var iv=setInterval(function(){ tries++; instant(); keep(); if(tries>20) clearInterval(iv); }, 400);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
